import React, { Component } from "react";
import { Link } from "react-router-dom";

import Modal from "react-bootstrap/Modal";

import UBXFormText from "./../../ubx/form/input";
import UBXButton from "./../../ubx/button";

import { borrowerForgotPassword } from "./../../../api/borrower";

export default class ForgotPasswordModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: "",
            formReady: false,
            userId: null,
            error: false,
            isBusy: false,
            linkSent: false,
            referenceNumber: false,
        };
    }

    async getPasswordRecoveryLink(userData) {
        try {
            const { data: forgotPasswordData = false } = await borrowerForgotPassword(userData);

            if (forgotPasswordData === false) {
                throw forgotPasswordData;
            }

            const { "reference_number": referenceNumber = false } = forgotPasswordData;

            await this.setState({
                isBusy: false,
            });

            await this.onSuccess(referenceNumber);
        } catch (error) {
            this.handleError(error);
        }
    }

    onClose(e) {
        const { onClose = false } = this.props;

        this.setState({
            linkSent: false,
            formReady: false,
        });

        if (onClose) {
            onClose(e);
        }
    }

    onOpenLogin(e) {
        const { onOpenLogin = false } = this.props;

        if (onOpenLogin) {
            onOpenLogin(e);
        }
    }

    onChange(name, value) {
        this.setState({ [name]: value });

        const { email } = this.state;
        let formReady = false;
        if (email !== "") {
            formReady = true;
        }

        this.setState({ formReady });
    }

    handleError(error) {
        if (error) {
            const { response } = error;

            if (response) {
                const { status } = response;

                switch (status) {
                    case 400:
                    default: {
                        const { data: responseData } = response;
                        if (responseData) {
                            const { data = false } = responseData;

                            let errorMessage = "An error has occurred";
                            if (data) {
                                const { message } = data;
                                errorMessage = message;
                            }

                            this.setState({
                                error: errorMessage,
                                isBusy: false,
                            });
                        } else {
                            alert(`An error occured:\n\n${response}`);
                        }
                        break;
                    }
                }
            }
        }
    }

    async onSubmit(e) {
        e.preventDefault();
        const { email, formReady } = this.state;

        const userData = {
            username: email.toLowerCase(),
        };

        this.setState({
            isBusy: true,
        });

        if (formReady) {
            await this.getPasswordRecoveryLink(userData);
        }

        return false;
    }

    async onSuccess(referenceNumber) {
        const { onSuccess = false } = this.props;

        if (onSuccess) {
            onSuccess(referenceNumber);
        }
    }

    render() {
        const { show = false } = this.props;
        const { error, isBusy, formReady } = this.state;

        return (
            <Modal id="forgot-password-modal" show={show} backdrop="static" centered onHide={(e) => this.onClose(e)}>
                <Modal.Header closeButton closeLabel="Close Forgot Password Modal">
                    <Modal.Title>Forgot Password</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div id="user-forgot-password">
                        <p>
                            Enter your SeekCap registered email address to receive a link to reset your password.
                        </p>
                        <form id="forgot-password-form" onSubmit={(e) => this.onSubmit(e)}>
                            <div className="user-fields">
                                <UBXFormText
                                    id="forgot-password-email"
                                    type="email"
                                    name="email"
                                    label="Email Address"
                                    required={true}
                                    onChange={(name, value) => this.onChange(name, value)}
                                    onSubmit={(e) => this.onSubmit(e)}
                                    errorMessage={"Invalid email address"}
                                />
                            </div>
                            <div className="user-fields">
                                <UBXButton
                                    id="forgot-password-button"
                                    type="primary"
                                    block={true}
                                    size="large"
                                    submit={true}
                                    disabled={isBusy || !formReady}
                                    form="forgot-password-form"
                                >
                                    Send recovery link
                                </UBXButton>
                            </div>
                        </form>
                        {error ? (
                            <em className="forgot-password-error" title={error}>
                                {error}
                            </em>
                        ) : (
                            ""
                        )}
                        <p>
                            Already have an account?{" "}
                            <Link
                                className="login-link"
                                to="/"
                                onClick={(e) => this.onOpenLogin(e)}
                                data-dismiss="modal"
                            >
                                Log in
                            </Link>
                        </p>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}
